<template>
  <div class="row mb-3">
    <div class="col-sm-12">
      <div class="card mb-3">

        <!-- Form body -->
        <div class="card-body">
          <form @submit.prevent="addUser">
            <!-- Input fields -->
            <div class="row g-3 align-items-center">
              <div class="col-md-6">
                <label class="form-label">Company</label>
                <select class="form-select" v-model.number="nitem.companyId" name="specialityDropdown">
                  <option></option>
                  <option v-for="(company, index) in companies" :key="index" :value="company.id">{{ company.name }}</option>
                </select>
                <span class="inputError">{{ errors.first('specialityDropdown') }}</span>
              </div>
              <div class="col-md-6">
                <label class="form-label">Role</label>
                <select class="form-select" v-model.number="nitem.roleId" name="specialityDropdown2" v-validate="{ required: true }" required>
                  <option></option>
                  <option v-for="(role, index) in roles" :key="index" :value="role.id">{{ role.name }}</option>
                </select>
                <span class="inputError">{{ errors.first('specialityDropdown2') }}</span>
              </div>
              <!-- Name -->
              <div class="col-md-6">
                <label for="firstName" class="form-label">Name</label>
                <input type="text" v-model="nitem.name"  name="name" id="firstName" class="form-control" v-validate="{ required: true }">
                <span class="inputError">{{ errors.first('name') }}</span>
              </div>

              <div class="col-md-6">
                <label for="lastname" class="form-label">Surname</label>
                <input type="text" v-model="nitem.surname"  name="surname" id="lastname" class="form-control" v-validate="{ required: true }">
                <span class="inputError">{{ errors.first('surname') }}</span>
              </div>

              <div class="col-md-6">
                <label for="email" class="form-label">Email</label>
                <input type="email" v-model="nitem.email"  name="email" id="email" class="form-control" v-validate="{ required: true }">
                <span class="inputError">{{ errors.first('email') }}</span>
              </div>
              <div class="col-md-6">
                <label for="password" class="form-label">Password</label>
                <input type="text" v-model="nitem.password"  name="password" id="password" class="form-control" v-validate="'required|min:8'">
                <span class="inputError">{{ errors.first('password') }}</span>
              </div>
            </div>
            <!-- Submit button -->
            <button type="submit" class="btn btn-primary mt-4" :disabled="loading">
              Save
            </button>
          </form>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import jwtInterceptor from '../../../jwt.interceptor'

export default {
  name: 'UserCreate',
  data() {
    return {
      nitem: {
        name: "",
        surname: "",
        companyId: 0,
        roleId: 0,
        email: "",
        password: ""
      },
      roles: [],
      companies: [],
      loading: false,
    }
  },
  methods: {
    async addUser() {

      const validForm = await this.isFormValid()
      if (validForm) {
        this.loading = true
        jwtInterceptor.post(this.$store.getters.getUrl + "/Users", this.nitem).then(response => {
          this.$toast.success("Added", {
              position: "top-right"
            })
            this.loading = false
            this.$router.back()
        }).catch((e) => {
          this.$toast.error(e.response.data.title, {
            position: "top-right"
          });
          this.loading = false
        })
      } 
      else {
        this.$toast.error("Cells are not filled correctly. Check the boxes again!", {
          position: "top-right"
        })
        this.loading = false
      }
    },
    getRoles() {
        jwtInterceptor.get(this.$store.getters.getUrl+'/Roles')
        .then( response => {
          this.roles = response.data;
        })
    },
    getCompanies() {
        jwtInterceptor.get(this.$store.getters.getUrl+'/Companies')
        .then( response => {
          this.companies = response.data;
        })
    },
    isFormValid() {
      // eslint-disable-next-line vue/no-async-in-computed-properties, no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const valid = await this.$validator.validate();
          resolve(valid);
        } catch (error) {
          reject(error);
        }
      });
    },
  },
  created() {
    this.getRoles();
    this.getCompanies();
  }
}
</script>

<style>
.smsCheckbox {
  height: 2.5rem;
  width: 2rem;
}
</style>